import React from "react";
import { IconButton, Tooltip } from "@mui/material";

/**
 * TableActions component used only for material table actions.
 * A component for rendering a list of actions in a table.
 *
 * @prop {{ row: object, index: number }} item - The row data for the current item.
 * @prop {Array<{ icon: ReactNode, type: string, label?: string, onClick: (row: object, type: string) => void, disabled?: boolean }>} actions - The list of actions to render.
 */
export const TableActions = ({ item, actions }) => {
  const handleAction = (event, actionType, onClick) => {
    event.stopPropagation();
    onClick(item.row, actionType);
  };

  return (
    <>
      {actions.map(({ icon: Icon, type, label, onClick, disabled = false }, index) => (
        <Tooltip key={index} title={label || type}>
          <IconButton onClick={(event) => !disabled && handleAction(event, type, onClick)} disabled={disabled}>
            <Icon style={{ fontSize: "1.25rem" }} />
          </IconButton>
        </Tooltip>
      ))}
    </>
  );
};
